<!--  -->
<template>
  <form class="ResetPasswordForm login-sign-form">
    <div class="form-put-title">{{ $t('lang108') }}</div>
    <country-select @on-change="countrySelectChange" />

    <div class="form-put-title">{{ $t('lang109') }}</div>
    <div class="phone-number-tab">
      <div class="phone-number-box phone-code-box">
        <p class="phone-number-prev">+{{ yourPhonePrevCode }}</p>
        <input v-model="yourPhoneNumber" />
      </div>
      <div
        :class="['btn-send', { 'btn-can-send': canSendCode }]"
        @click="getVerficationCode"
        v-text="countTxt"
      ></div>
    </div>

    <div class="form-put-title">{{ $t('lang112') }}</div>
    <div class="form-put-vcode">
      <div id="captcha-box-reset" class="captcha-box"></div>
    </div>

    <div class="form-put-title">{{ $t('lang113') }}</div>
    <div class="password-tab">
      <input v-model="verficationCode" type="text" />
    </div>

    <div class="form-put-title">{{ $t('lang117') }}</div>
    <div class="password-tab">
      <input v-model="password" type="password" />
    </div>

    <div
      :class="['btn-sumbit', { 'btn-loading': loading, 'btn-gray': btnGray }]"
      type="button"
      @click="resetPassword"
    >
      <span v-if="loading" class="icon-loading">
        <img :src="require('@assets/img/loading.gif')" />
      </span>
      {{ $t('lang172') }}
    </div>
  </form>
</template>

<script>
import { statusCodeMapping } from '@constant';
import CountrySelect from './CountrySelect';
import codeCounter from './codeCounter';

export default {
  components: {
    CountrySelect
  },
  mixins: [codeCounter],
  data() {
    return {
      yourCountryName: '',
      yourCountryCode: '',
      yourPhonePrevCode: '',
      yourPhoneNumber: '',
      password: '',
      captchaToken: '',
      verficationCode: '',
      btnCodeCanClick: true,
      // 验证码发送按钮文案
      countTxt: 'Send',
      loading: false
    };
  },
  computed: {
    canSendCode() {
      if (!this.btnCodeCanClick) {
        return false;
      }

      const { yourPhoneNumber, captchaToken, yourPhonePrevCode } = this;
      if (
        yourPhoneNumber.length === 0 ||
        yourPhonePrevCode.length === 0 ||
        captchaToken.length === 0
      ) {
        return false;
      }

      return true;
    },
    btnGray() {
      if (!this.yourPhoneNumber || !this.password || !this.verficationCode) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    setTimeout(() => {
      this.initCaptcha();
    }, 0);
  },
  methods: {
    countrySelectChange(val) {
      const { countryName, countryCode, phonePrevCode } = val;
      this.yourCountryName = countryName;
      this.yourCountryCode = countryCode;
      this.yourPhonePrevCode = phonePrevCode;
    },
    // 登录校验滑块加载
    initCaptcha() {
      const captchaSize = {
        width: '300px',
        height: '40px',
        fontsize: '14px',
        business: 'bigolive-web',
        scene: 'register'
      };
      this.captchaLogin = new window.BigoCaptcha.Captcha();
      this.captchaLogin.initWithParams(
        {
          id: 'captcha-box-reset',
          ...captchaSize
        },
        (res) => {
          if (res && res.status === 2) {
            this.captchaToken = res.token;
          }
        }
      );
    },
    // 获取验证码
    async getVerficationCode() {
      if (!this.btnCodeCanClick) return;
      const { yourPhoneNumber, captchaToken, yourPhonePrevCode } = this;
      let errorTips = '';
      if (yourPhoneNumber.length === 0) {
        errorTips = statusCodeMapping[101];
      }
      if (yourPhonePrevCode.length === 0) {
        errorTips = statusCodeMapping[100];
      }
      if (captchaToken.length === 0) {
        errorTips = statusCodeMapping.register_vcode;
      }
      if (errorTips) return this.$toast(this.$t(errorTips));

      const data = {
        interfaceName: 'sendCode',
        phone: yourPhoneNumber,
        phone_code: yourPhonePrevCode,
        is_reset: 0,
        vcode: captchaToken
      };
      const res = await this.$api.sendCode(data);
      if (res && res.code === 0) {
        // 出弹窗
        this.$toast(this.$t(statusCodeMapping[110]));
        this.sendCodeCounter();
        this.$log && this.$log.info('sendCode success', { msg: res.code });
      } else {
        this.$toast(
          statusCodeMapping[res.code]
            ? this.$t(statusCodeMapping[res.code])
            : `${res?.code}: ${res?.msg}`
        );
        this.$log && this.$log.error('sendCode error', { msg: res.code });
      }
      this.initCaptcha();
    },
    async resetPassword() {
      const {
        yourPhoneNumber,
        verficationCode,
        yourPhonePrevCode,
        password
      } = this;
      let errorTips = '';
      if (password.length < 6 || password.length > 16) {
        errorTips = statusCodeMapping[104];
      } else if (!/^\w{6,16}$/.test(password)) {
        errorTips = statusCodeMapping[105];
      } else if (verficationCode.length === 0) {
        errorTips = statusCodeMapping[102];
      } else if (yourPhoneNumber.length === 0) {
        errorTips = statusCodeMapping[101];
      }
      if (errorTips) return this.$toast(this.$t(errorTips));

      const data = {
        phone: yourPhoneNumber,
        code: verficationCode,
        pwd: password,
        phone_code: yourPhonePrevCode
      };

      this.loading = true;
      const res = await this.$api.updatePassword(data);
      if (res && +res.code === 0) {
        this.$toast('Success');
        this.$log && this.$log.info('resetPsw success', { msg: res.code });
        window.location.reload();
      } else {
        this.$toast(
          statusCodeMapping[res.code]
            ? this.$t(statusCodeMapping[res.code])
            : `${res?.code}: ${res?.msg}`
        );
        this.$log && this.$log.error('resetPsw error', { msg: res.code });
      }
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './form.scss';
</style>
